import React, { CSSProperties } from "react";

export default function IconBilling(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				fill={props.color ?? "black"}
				d="M10.33 8.47h.92v2.78h-.92c-.93 0-1.58-.68-1.58-1.39s.65-1.39 1.58-1.39m2.42 7.06v-2.78h.92c.93 0 1.58.68 1.58 1.39s-.65 1.39-1.58 1.39z"
			/>
			<path
				fill={props.color ?? "black"}
				d="M10.57 2.08a3.3 3.3 0 0 1 2.87 0c.39.18.75.5 1.26.92l.07.07c.48.4.94.6 1.58.65l.1.01c.67.06 1.14.1 1.55.24A3.3 3.3 0 0 1 20.03 6c.15.4.19.88.24 1.54v.1c.06.65.25 1.1.66 1.59l.07.07c.43.51.74.87.93 1.27a3.3 3.3 0 0 1 0 2.87c-.2.39-.5.75-.93 1.26l-.07.07c-.42.5-.6.96-.65 1.58l-.01.1c-.05.67-.1 1.14-.24 1.55A3.3 3.3 0 0 1 18 20.03c-.4.15-.88.19-1.54.24h-.1c-.65.06-1.1.25-1.59.66l-.07.07c-.51.43-.87.74-1.26.93a3.3 3.3 0 0 1-2.87 0c-.4-.2-.76-.5-1.26-.93l-.08-.07c-.44-.4-1-.62-1.58-.65l-.1-.01c-.67-.05-1.14-.1-1.55-.24A3.3 3.3 0 0 1 3.97 18c-.15-.4-.18-.88-.24-1.54v-.1a2.6 2.6 0 0 0-.66-1.59L3 14.7c-.43-.51-.74-.87-.92-1.26a3.3 3.3 0 0 1 0-2.87c.18-.4.5-.76.92-1.26l.07-.08c.4-.44.62-1 .65-1.58l.01-.1c.06-.67.1-1.14.24-1.55A3.3 3.3 0 0 1 6 3.97c.4-.15.88-.18 1.54-.24h.1a2.6 2.6 0 0 0 1.59-.66L9.3 3c.51-.43.87-.74 1.27-.92m2.18 4.42a.75.75 0 0 0-1.5 0v.47h-.92c-1.64 0-3.08 1.24-3.08 2.9 0 1.65 1.44 2.88 3.08 2.88h.92v2.78H8a.75.75 0 1 0 0 1.5h3.25v.47a.75.75 0 0 0 1.5 0v-.47h.92c1.64 0 3.08-1.23 3.08-2.9 0-1.65-1.44-2.88-3.08-2.88h-.92V8.47h2.58a.75.75 0 0 0 0-1.5h-2.58z"
			/>
		</svg>
	);
}
